<div class="modal-header px-4 justify-content-between">
  <h4 class="modal-title header-13">
    {{ configs.title }}
  </h4>
  <div>
    <button
      type="button"
      class="btn-close btn-close-white"
      aria-label="Close"
      (click)="activeModal.dismiss('Cross click')"
    ></button>
  </div>
</div>
<div class="modal-body progress-modal w-100 d-flex flex-column">
  <app-progress-bar
    [text]="progressText"
    [progress]="percentage"
  ></app-progress-bar>
  <div class="d-flex justify-content-end footer">
    <button
      class="btn btn-accello-primary mx-2 btn-spin m-auto me-0"
      (click)="activeModal.dismiss('Cross click')"
    >
      <span>Close</span>
    </button>
  </div>
</div>
